
import { Vue } from "vue-class-component";

export default class BulkBookingV2 extends Vue {}
